// Shift-clicking selects a single consecutive list of items
// starting at the previous click.
var getClickedRange = function getClickedRange(clickedId, displayedPartialTree, isShiftKeyPressed, lastCheckbox) {
  var lastCheckboxIndex = displayedPartialTree.findIndex(function (item) {
    return item.id === lastCheckbox;
  });

  if (lastCheckboxIndex !== -1 && isShiftKeyPressed) {
    var newCheckboxIndex = displayedPartialTree.findIndex(function (item) {
      return item.id === clickedId;
    });
    var clickedRange = displayedPartialTree.slice(Math.min(lastCheckboxIndex, newCheckboxIndex), Math.max(lastCheckboxIndex, newCheckboxIndex) + 1);
    return clickedRange.map(function (item) {
      return item.id;
    });
  }

  return [clickedId];
};

export default getClickedRange;